// The approaches facet keeps TherapyFinder's `service=` URL key, but `service` collides with
// Ember's service name. Controller and query state use `approaches`,catalog matching and
// router transitions use `service`.
export const CONTROLLER_PROPERTY_BY_QUERY_PARAM = Object.freeze({ service: 'approaches' });

const QUERY_PARAM_BY_CONTROLLER_PROPERTY = Object.freeze(
  Object.fromEntries(
    Object.entries(CONTROLLER_PROPERTY_BY_QUERY_PARAM).map(([param, property]) => [property, param])
  )
);

export function queryParamKeyFor(name) {
  return QUERY_PARAM_BY_CONTROLLER_PROPERTY[name] ?? name;
}

export function controllerPropertyFor(queryParam) {
  return CONTROLLER_PROPERTY_BY_QUERY_PARAM[queryParam] ?? queryParam;
}

// Router transitions and the catalog only understand URL keys,
// while route params and callers may use either spelling.
// A defined value always wins over an undefined one for the same key.
export function toQueryParamKeys(params = {}) {
  let normalized = {};
  for (let [name, value] of Object.entries(params)) {
    let key = queryParamKeyFor(name);
    if (value === undefined && key in normalized) {
      continue;
    }
    normalized[key] = value;
  }
  return normalized;
}

// Controller `queryParams` entries: a plain name, or `{ approaches: 'service' }` when aliased.
export function controllerQueryParamsFor(queryParams = []) {
  return queryParams.map(queryParam => {
    let property = controllerPropertyFor(queryParam);
    return property === queryParam ? queryParam : { [property]: queryParam };
  });
}

// Route `queryParams` config is keyed by controller property name; `as` supplies the URL key.
export function routeQueryParamsFor(queryParams = [], options = {}) {
  return Object.fromEntries(
    queryParams.map(queryParam => {
      let property = controllerPropertyFor(queryParam);
      return [property, property === queryParam ? { ...options } : { as: queryParam, ...options }];
    })
  );
}
